// SPDX-License-Identifier: MIT
import { Cryptocurrency } from './cryptocurrency';
import { Adcoin } from './adcoin';
import { AkashNetwork } from './akashnetwork';
import { Algorand } from './algorand';
import { Anon } from './anon';
import { Aptos } from './aptos';
import { Arbitrum } from './arbitum';
import { Argoneum } from './argoneum';
import { Artax } from './artax';
import { Aryacoin } from './aryacoin';
import { Asiacoin } from './asiacoin';
import { Auroracoin } from './auroracoin';
import { Avalanche } from './avalanche';
import { Avian } from './avian';
import { Axe } from './axe';
import { Axelar } from './axelar';
import { BandProtocol } from './bandprotocol';
import { Base } from './base';
import { Bata } from './bata';
import { BeetleCoin } from './beetlecoin';
import { BelaCoin } from './belacoin';
import { Binance } from './binance';
import { BitCloud } from './bitcloud';
import { Bitcoin } from './bitcoin';
import { BitcoinAtom } from './bitcoinatom';
import { BitcoinCash } from './bitcoincash';
import { BitcoinCashSLP } from './bitcoincashslp';
import { BitcoinGold } from './bitcoingold';
import { BitcoinGreen } from './bitcoingreen';
import { BitcoinPlus } from './bitcoinplus';
import { BitcoinPrivate } from './bitcoinprivate';
import { BitcoinSV } from './bitcoinsv';
import { BitcoinZ } from './bitcoinz';
import { Bitcore } from './bitcore';
import { BitSend } from './bitsend';
import { Blackcoin } from './blackcoin';
import { Blocknode } from './blocknode';
import { BlockStamp } from './blockstamp';
import { Bolivarcoin } from './bolivarcoin';
import { BritCoin } from './britcoin';
import { CanadaECoin } from './canadaecoin';
import { Cannacoin } from './cannacoin';
import { Cardano } from './cardano';
import { Celo } from './celo';
import { Chihuahua } from './chihuahua';
import { Clams } from './clams';
import { ClubCoin } from './clubcoin';
import { Compcoin } from './compcoin';
import { Cosmos } from './cosmos';
import { CPUChain } from './cpuchain';
import { CranePay } from './cranepay';
import { Crave } from './crave';
import { Dash } from './dash';
import { DeepOnion } from './deeponion';
import { Defcoin } from './defcoin';
import { Denarius } from './denarius';
import { Diamond } from './diamond';
import { DigiByte } from './digibyte';
import { Digitalcoin } from './digitalcoin';
import { Divi } from './divi';
import { Dogecoin } from './dogecoin';
import { dYdX } from './dydx';
import { eCash } from './ecash';
import { ECoin } from './ecoin';
import { EDRCoin } from './edrcoin';
import { eGulden } from './egulden';
import { Einsteinium } from './einsteinium';
import { Elastos } from './elastos';
import { Energi } from './energi';
import { EOS } from './eos';
import { Ergo } from './ergo';
import { Ethereum } from './ethereum';
import { EuropeCoin } from './europecoin';
import { Evrmore } from './evrmore';
import { ExclusiveCoin } from './exclusivecoin';
import { Fantom } from './fantom';
import { Feathercoin } from './feathercoin';
import { FetchAI } from './fetchai';
import { Filecoin } from './filecoin';
import { Firo } from './firo';
import { Firstcoin } from './firstcoin';
import { FIX } from './fix';
import { Flashcoin } from './flashcoin';
import { Flux } from './flux';
import { Foxdcoin } from './foxdcoin';
import { FujiCoin } from './fujicoin';
import { GameCredits } from './gamecredits';
import { GCRCoin } from './gcrcoin';
import { GoByte } from './gobyte';
import { Gridcoin } from './gridcoin';
import { GroestlCoin } from './groestlcoin';
import { Gulden } from './gulden';
import { Harmony } from './harmony';
import { Helleniccoin } from './helleniccoin';
import { Hempcoin } from './hempcoin';
import { Horizen } from './horizen';
import { HuobiToken } from './huobitoken';
import { Hush } from './hush';
import { Icon } from './icon';
import { Injective } from './injective';
import { InsaneCoin } from './insanecoin';
import { InternetOfPeople } from './internetofpeople';
import { IRISnet } from './irisnet';
import { IXCoin } from './ixcoin';
import { Jumbucks } from './jumbucks';
import { Kava } from './kava';
import { Kobocoin } from './kobocoin';
import { Komodo } from './komodo';
import { Landcoin } from './landcoin';
import { LBRYCredits } from './lbrycredits';
import { Linx } from './linx';
import { Litecoin } from './litecoin';
import { LitecoinCash } from './litecoincash';
import { LitecoinZ } from './litecoinz';
import { Lkrcoin } from './lkrcoin';
import { Lynx } from './lynx';
import { Mazacoin } from './mazacoin';
import { Megacoin } from './megacoin';
import { Metis } from './metis';
import { Minexcoin } from './minexcoin';
import { Monacoin } from './monacoin';
import { Monero } from './monero';
import { Monk } from './monk';
import { MultiversX } from './multiversx';
import { Myriadcoin } from './myriadcoin';
import { Namecoin } from './namecoin';
import { Nano } from './nano';
import { Navcoin } from './navcoin';
import { Near } from './near';
import { Neblio } from './neblio';
import { Neo } from './neo';
import { Neoscoin } from './neoscoin';
import { Neurocoin } from './neurocoin';
import { Neutron } from './neutron';
import { NewYorkCoin } from './newyorkcoin';
import { NineChronicles } from './ninechronicles';
import { NIX } from './nix';
import { Novacoin } from './novacoin';
import { NuBits } from './nubits';
import { NuShares } from './nushares';
import { OKCash } from './okcash';
import { OKTChain } from './oktchain';
import { Omni } from './omni';
import { Onix } from './onix';
import { Ontology } from './ontology';
import { Optimism } from './optimism';
import { Osmosis } from './osmosis';
import { Particl } from './particl';
import { Peercoin } from './peercoin';
import { Pesobit } from './pesobit';
import { Phore } from './phore';
import { PiNetwork } from './pinetwork';
import { Pinkcoin } from './pinkcoin';
import { Pivx } from './pivx';
import { Polygon } from './polygon';
import { PoSWCoin } from './poswcoin';
import { Potcoin } from './potcoin';
import { ProjectCoin } from './projectcoin';
import { Putincoin } from './putincoin';
import { Qtum } from './qtum';
import { Rapids } from './rapids';
import { Ravencoin } from './ravencoin';
import { Reddcoin } from './reddcoin';
import { Ripple } from './ripple';
import { Ritocoin } from './ritocoin';
import { RSK } from './rsk';
import { Rubycoin } from './rubycoin';
import { Safecoin } from './safecoin';
import { Saluscoin } from './saluscoin';
import { Scribe } from './scribe';
import { Secret } from './secret';
import { ShadowCash } from './shadowcash';
import { Shentu } from './shentu';
import { Slimcoin } from './slimcoin';
import { Smileycoin } from './smileycoin';
import { Solana } from './solana';
import { Solarcoin } from './solarcoin';
import { Stafi } from './stafi';
import { Stash } from './stash';
import { Stellar } from './stellar';
import { Stratis } from './stratis';
import { Sugarchain } from './sugarchain';
import { Sui } from './sui';
import { Syscoin } from './syscoin';
import { Terra } from './terra';
import { Tezos } from './tezos';
import { Theta } from './theta';
import { ThoughtAI } from './thoughtai';
import { TOACoin } from './toacoin';
import { Tron } from './tron';
import { TWINS } from './twins';
import { UltimateSecureCash } from './ultimatesecurecash';
import { Unobtanium } from './unobtanium';
import { Vcash } from './vcash';
import { VeChain } from './vechain';
import { Verge } from './verge';
import { Vertcoin } from './vertcoin';
import { Viacoin } from './viacoin';
import { Vivo } from './vivo';
import { Voxels } from './voxels';
import { VPNCoin } from './vpncoin';
import { Wagerr } from './wagerr';
import { Whitecoin } from './whitecoin';
import { Wincoin } from './wincoin';
import { XinFin } from './xinfin';
import { XUEZ } from './xuez';
import { Ycash } from './ycash';
import { Zcash } from './zcash';
import { ZClassic } from './zclassic';
import { Zetacoin } from './zetacoin';
import { Zilliqa } from './zilliqa';
import { ZooBC } from './zoobc';
import { CryptocurrencyError, SymbolError } from '../exceptions';
export class CRYPTOCURRENCIES {
    static dictionary = {
        [Adcoin.NAME]: Adcoin,
        [AkashNetwork.NAME]: AkashNetwork,
        [Algorand.NAME]: Algorand,
        [Anon.NAME]: Anon,
        [Aptos.NAME]: Aptos,
        [Arbitrum.NAME]: Arbitrum,
        [Argoneum.NAME]: Argoneum,
        [Artax.NAME]: Artax,
        [Aryacoin.NAME]: Aryacoin,
        [Asiacoin.NAME]: Asiacoin,
        [Auroracoin.NAME]: Auroracoin,
        [Avalanche.NAME]: Avalanche,
        [Avian.NAME]: Avian,
        [Axe.NAME]: Axe,
        [Axelar.NAME]: Axelar,
        [BandProtocol.NAME]: BandProtocol,
        [Base.NAME]: Base,
        [Bata.NAME]: Bata,
        [BeetleCoin.NAME]: BeetleCoin,
        [BelaCoin.NAME]: BelaCoin,
        [Binance.NAME]: Binance,
        [BitCloud.NAME]: BitCloud,
        [Bitcoin.NAME]: Bitcoin,
        [BitcoinAtom.NAME]: BitcoinAtom,
        [BitcoinCash.NAME]: BitcoinCash,
        [BitcoinCashSLP.NAME]: BitcoinCashSLP,
        [BitcoinGold.NAME]: BitcoinGold,
        [BitcoinGreen.NAME]: BitcoinGreen,
        [BitcoinPlus.NAME]: BitcoinPlus,
        [BitcoinPrivate.NAME]: BitcoinPrivate,
        [BitcoinSV.NAME]: BitcoinSV,
        [BitcoinZ.NAME]: BitcoinZ,
        [Bitcore.NAME]: Bitcore,
        [BitSend.NAME]: BitSend,
        [Blackcoin.NAME]: Blackcoin,
        [Blocknode.NAME]: Blocknode,
        [BlockStamp.NAME]: BlockStamp,
        [Bolivarcoin.NAME]: Bolivarcoin,
        [BritCoin.NAME]: BritCoin,
        [CanadaECoin.NAME]: CanadaECoin,
        [Cannacoin.NAME]: Cannacoin,
        [Cardano.NAME]: Cardano,
        [Celo.NAME]: Celo,
        [Chihuahua.NAME]: Chihuahua,
        [Clams.NAME]: Clams,
        [ClubCoin.NAME]: ClubCoin,
        [Compcoin.NAME]: Compcoin,
        [Cosmos.NAME]: Cosmos,
        [CPUChain.NAME]: CPUChain,
        [CranePay.NAME]: CranePay,
        [Crave.NAME]: Crave,
        [Dash.NAME]: Dash,
        [DeepOnion.NAME]: DeepOnion,
        [Defcoin.NAME]: Defcoin,
        [Denarius.NAME]: Denarius,
        [Diamond.NAME]: Diamond,
        [DigiByte.NAME]: DigiByte,
        [Digitalcoin.NAME]: Digitalcoin,
        [Divi.NAME]: Divi,
        [Dogecoin.NAME]: Dogecoin,
        [dYdX.NAME]: dYdX,
        [eCash.NAME]: eCash,
        [ECoin.NAME]: ECoin,
        [EDRCoin.NAME]: EDRCoin,
        [eGulden.NAME]: eGulden,
        [Einsteinium.NAME]: Einsteinium,
        [Elastos.NAME]: Elastos,
        [Energi.NAME]: Energi,
        [EOS.NAME]: EOS,
        [Ergo.NAME]: Ergo,
        [Ethereum.NAME]: Ethereum,
        [EuropeCoin.NAME]: EuropeCoin,
        [Evrmore.NAME]: Evrmore,
        [ExclusiveCoin.NAME]: ExclusiveCoin,
        [Fantom.NAME]: Fantom,
        [Feathercoin.NAME]: Feathercoin,
        [FetchAI.NAME]: FetchAI,
        [Filecoin.NAME]: Filecoin,
        [Firo.NAME]: Firo,
        [Firstcoin.NAME]: Firstcoin,
        [FIX.NAME]: FIX,
        [Flashcoin.NAME]: Flashcoin,
        [Flux.NAME]: Flux,
        [Foxdcoin.NAME]: Foxdcoin,
        [FujiCoin.NAME]: FujiCoin,
        [GameCredits.NAME]: GameCredits,
        [GCRCoin.NAME]: GCRCoin,
        [GoByte.NAME]: GoByte,
        [Gridcoin.NAME]: Gridcoin,
        [GroestlCoin.NAME]: GroestlCoin,
        [Gulden.NAME]: Gulden,
        [Harmony.NAME]: Harmony,
        [Helleniccoin.NAME]: Helleniccoin,
        [Hempcoin.NAME]: Hempcoin,
        [Horizen.NAME]: Horizen,
        [HuobiToken.NAME]: HuobiToken,
        [Hush.NAME]: Hush,
        [Icon.NAME]: Icon,
        [Injective.NAME]: Injective,
        [InsaneCoin.NAME]: InsaneCoin,
        [InternetOfPeople.NAME]: InternetOfPeople,
        [IRISnet.NAME]: IRISnet,
        [IXCoin.NAME]: IXCoin,
        [Jumbucks.NAME]: Jumbucks,
        [Kava.NAME]: Kava,
        [Kobocoin.NAME]: Kobocoin,
        [Komodo.NAME]: Komodo,
        [Landcoin.NAME]: Landcoin,
        [LBRYCredits.NAME]: LBRYCredits,
        [Linx.NAME]: Linx,
        [Litecoin.NAME]: Litecoin,
        [LitecoinCash.NAME]: LitecoinCash,
        [LitecoinZ.NAME]: LitecoinZ,
        [Lkrcoin.NAME]: Lkrcoin,
        [Lynx.NAME]: Lynx,
        [Mazacoin.NAME]: Mazacoin,
        [Megacoin.NAME]: Megacoin,
        [Metis.NAME]: Metis,
        [Minexcoin.NAME]: Minexcoin,
        [Monacoin.NAME]: Monacoin,
        [Monero.NAME]: Monero,
        [Monk.NAME]: Monk,
        [MultiversX.NAME]: MultiversX,
        [Myriadcoin.NAME]: Myriadcoin,
        [Namecoin.NAME]: Namecoin,
        [Nano.NAME]: Nano,
        [Navcoin.NAME]: Navcoin,
        [Near.NAME]: Near,
        [Neblio.NAME]: Neblio,
        [Neo.NAME]: Neo,
        [Neoscoin.NAME]: Neoscoin,
        [Neurocoin.NAME]: Neurocoin,
        [Neutron.NAME]: Neutron,
        [NewYorkCoin.NAME]: NewYorkCoin,
        [NineChronicles.NAME]: NineChronicles,
        [NIX.NAME]: NIX,
        [Novacoin.NAME]: Novacoin,
        [NuBits.NAME]: NuBits,
        [NuShares.NAME]: NuShares,
        [OKCash.NAME]: OKCash,
        [OKTChain.NAME]: OKTChain,
        [Omni.NAME]: Omni,
        [Onix.NAME]: Onix,
        [Ontology.NAME]: Ontology,
        [Optimism.NAME]: Optimism,
        [Osmosis.NAME]: Osmosis,
        [Particl.NAME]: Particl,
        [Peercoin.NAME]: Peercoin,
        [Pesobit.NAME]: Pesobit,
        [Phore.NAME]: Phore,
        [PiNetwork.NAME]: PiNetwork,
        [Pinkcoin.NAME]: Pinkcoin,
        [Pivx.NAME]: Pivx,
        [Polygon.NAME]: Polygon,
        [PoSWCoin.NAME]: PoSWCoin,
        [Potcoin.NAME]: Potcoin,
        [ProjectCoin.NAME]: ProjectCoin,
        [Putincoin.NAME]: Putincoin,
        [Qtum.NAME]: Qtum,
        [Rapids.NAME]: Rapids,
        [Ravencoin.NAME]: Ravencoin,
        [Reddcoin.NAME]: Reddcoin,
        [Ripple.NAME]: Ripple,
        [Ritocoin.NAME]: Ritocoin,
        [RSK.NAME]: RSK,
        [Rubycoin.NAME]: Rubycoin,
        [Safecoin.NAME]: Safecoin,
        [Saluscoin.NAME]: Saluscoin,
        [Scribe.NAME]: Scribe,
        [Secret.NAME]: Secret,
        [ShadowCash.NAME]: ShadowCash,
        [Shentu.NAME]: Shentu,
        [Slimcoin.NAME]: Slimcoin,
        [Smileycoin.NAME]: Smileycoin,
        [Solana.NAME]: Solana,
        [Solarcoin.NAME]: Solarcoin,
        [Stafi.NAME]: Stafi,
        [Stash.NAME]: Stash,
        [Stellar.NAME]: Stellar,
        [Stratis.NAME]: Stratis,
        [Sugarchain.NAME]: Sugarchain,
        [Sui.NAME]: Sui,
        [Syscoin.NAME]: Syscoin,
        [Terra.NAME]: Terra,
        [Tezos.NAME]: Tezos,
        [Theta.NAME]: Theta,
        [ThoughtAI.NAME]: ThoughtAI,
        [TOACoin.NAME]: TOACoin,
        [Tron.NAME]: Tron,
        [TWINS.NAME]: TWINS,
        [UltimateSecureCash.NAME]: UltimateSecureCash,
        [Unobtanium.NAME]: Unobtanium,
        [Vcash.NAME]: Vcash,
        [VeChain.NAME]: VeChain,
        [Verge.NAME]: Verge,
        [Vertcoin.NAME]: Vertcoin,
        [Viacoin.NAME]: Viacoin,
        [Vivo.NAME]: Vivo,
        [Voxels.NAME]: Voxels,
        [VPNCoin.NAME]: VPNCoin,
        [Wagerr.NAME]: Wagerr,
        [Whitecoin.NAME]: Whitecoin,
        [Wincoin.NAME]: Wincoin,
        [XinFin.NAME]: XinFin,
        [XUEZ.NAME]: XUEZ,
        [Ycash.NAME]: Ycash,
        [Zcash.NAME]: Zcash,
        [ZClassic.NAME]: ZClassic,
        [Zetacoin.NAME]: Zetacoin,
        [Zilliqa.NAME]: Zilliqa,
        [ZooBC.NAME]: ZooBC,
    };
    static getNames() {
        return Object.keys(this.dictionary);
    }
    static getClasses() {
        return Object.values(this.dictionary);
    }
    static getCryptocurrencyClass(name) {
        if (!this.isCryptocurrency(name)) {
            throw new CryptocurrencyError('Invalid cryptocurrency name', { expected: this.getNames(), got: name });
        }
        return this.dictionary[name];
    }
    static isCryptocurrency(name) {
        return name in this.dictionary;
    }
}
export function getCryptocurrency(symbol) {
    for (const cls of CRYPTOCURRENCIES.getClasses()) {
        if (cls.SYMBOL === symbol) {
            return cls;
        }
    }
    throw new SymbolError(`Cryptocurrency not found with symbol ${symbol}`);
}
export { Cryptocurrency, Adcoin, AkashNetwork, Algorand, Anon, Aptos, Arbitrum, Argoneum, Artax, Aryacoin, Asiacoin, Auroracoin, Avalanche, Avian, Axe, Axelar, BandProtocol, Base, Bata, BeetleCoin, BelaCoin, Binance, BitCloud, Bitcoin, BitcoinAtom, BitcoinCash, BitcoinCashSLP, BitcoinGold, BitcoinGreen, BitcoinPlus, BitcoinPrivate, BitcoinSV, BitcoinZ, Bitcore, BitSend, Blackcoin, Blocknode, BlockStamp, Bolivarcoin, BritCoin, CanadaECoin, Cannacoin, Cardano, Celo, Chihuahua, Clams, ClubCoin, Compcoin, Cosmos, CPUChain, CranePay, Crave, Dash, DeepOnion, Defcoin, Denarius, Diamond, DigiByte, Digitalcoin, Divi, Dogecoin, dYdX, eCash, ECoin, EDRCoin, eGulden, Einsteinium, Elastos, Energi, EOS, Ergo, Ethereum, EuropeCoin, Evrmore, ExclusiveCoin, Fantom, Feathercoin, FetchAI, Filecoin, Firo, Firstcoin, FIX, Flashcoin, Flux, Foxdcoin, FujiCoin, GameCredits, GCRCoin, GoByte, Gridcoin, GroestlCoin, Gulden, Harmony, Helleniccoin, Hempcoin, Horizen, HuobiToken, Hush, Icon, Injective, InsaneCoin, InternetOfPeople, IRISnet, IXCoin, Jumbucks, Kava, Kobocoin, Komodo, Landcoin, LBRYCredits, Linx, Litecoin, LitecoinCash, LitecoinZ, Lkrcoin, Lynx, Mazacoin, Megacoin, Metis, Minexcoin, Monacoin, Monero, Monk, MultiversX, Myriadcoin, Namecoin, Nano, Navcoin, Near, Neblio, Neo, Neoscoin, Neurocoin, Neutron, NewYorkCoin, NineChronicles, NIX, Novacoin, NuBits, NuShares, OKCash, OKTChain, Omni, Onix, Ontology, Optimism, Osmosis, Particl, Peercoin, Pesobit, Phore, PiNetwork, Pinkcoin, Pivx, Polygon, PoSWCoin, Potcoin, ProjectCoin, Putincoin, Qtum, Rapids, Ravencoin, Reddcoin, Ripple, Ritocoin, RSK, Rubycoin, Safecoin, Saluscoin, Scribe, Secret, ShadowCash, Shentu, Slimcoin, Smileycoin, Solana, Solarcoin, Stafi, Stash, Stellar, Stratis, Sugarchain, Sui, Syscoin, Terra, Tezos, Theta, ThoughtAI, TOACoin, Tron, TWINS, UltimateSecureCash, Unobtanium, Vcash, VeChain, Verge, Vertcoin, Viacoin, Vivo, Voxels, VPNCoin, Wagerr, Whitecoin, Wincoin, XinFin, XUEZ, Ycash, Zcash, ZClassic, Zetacoin, Zilliqa, ZooBC };
//# sourceMappingURL=index.js.map